export default class Model{
    constructor(){
        this.initValues = {}
    }

    getPropertyKeys(){
        return Object.keys(this).filter((x)=>x != 'initValues')
    }

    init(){
        this.getPropertyKeys().forEach((k)=>{
            this.initValues[k] = this[k]
        })
    }

    toFormData(){
        let fData = new FormData()
        this.getPropertyKeys().forEach((k)=>{
            fData.append(k, this[k])
        })
        return fData
    }
    
    reset(){
        this.getPropertyKeys().forEach((k)=>{
            this[k] = this.initValues[k]
        })
    }
}